import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { FallbackProps } from 'react-error-boundary';

const ErrorFallback: React.FC<FallbackProps> = ({ error }) => {
  const isCodeLoadingError = error && /loading chunk|chunkloaderror|failed to fetch/i.test(error.message);

  if (isCodeLoadingError) {
    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
          textAlign: 'center'
        }}
      >
        <Typography variant="h4" component="h2" gutterBottom>
          Chyba při načítání verze aplikace
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, maxWidth: 600 }}>
          Došlo k chybě při stahování aktualizovaného kódu. Je pravděpodobné, že je dostupná nová verze. Prosím, obnovte
          stránku, abyste stáhli nejnovější soubory.
        </Typography>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Obnovit aplikaci
        </Button>
      </Box>
    );
  }

  console.error('Unhandled application error:', error);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        textAlign: 'center'
      }}
    >
      <Typography variant="h4" component="h2" gutterBottom>
        Neočekávaná chyba
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Omlouváme se, nastala neočekávaná chyba.
      </Typography>
      <Button variant="outlined" onClick={() => window.location.reload()}>
        Zkusit znovu
      </Button>
    </Box>
  );
};

export default ErrorFallback;
